import { shallowEqual, useSelector } from 'react-redux'
import { selectors } from '../reducers/filesReducer'

export default function useFiles(selector) {
  return useSelector(state => selector(state.files), shallowEqual)
}

export { selectors }
